/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

(function (window, $) {
  'use strict';
  var document = window.document;

  var searchForm = {
    init: function () {
      $(document).on('submit', '.search-form form', function (e) {
        e.preventDefault();
        var $form = $(this);
        var link = $form.attr('action') + '?' + $form.serialize();
        $(document).trigger('_load_link', link);
      });
    },

    submitOverride: function () {
      $('.header .search-form form').submit(function () {
        return $(this).find('input.form-control').val().length > 0;
      });
    },
  };

  $(document).ready(function () {
    //searchForm.init();
    searchForm.submitOverride();
    var current_href = location.href;
    setInterval(function () {
      if (current_href !== location.href) {
        let hashIndex = location.href.indexOf('#q=');
        if (hashIndex >= 0) {
          let hash = location.href.substring(hashIndex);
          var oldUrl = $('.wpml-ls-item a').attr('href').split('#')[0];
          $('.wpml-ls-item a').attr('href', oldUrl + hash);
        }

        let searchPublication = location.href.indexOf('?');
        if (searchPublication >= 0) {
          let hashPublication = location.href.substring(searchPublication);
          var oldUrlPublication = $('.wpml-ls-item a').attr('href');
          $('.wpml-ls-item a').attr('href', oldUrlPublication.split('?')[0] + hashPublication + '&changeLang=true');
        }
        current_href = location.href;
      }
    }, 1000);

    if (window.location.hash) {
      var hash = window.location.hash.substring(0); //Puts hash in variable, and removes the # character
      if (hash.indexOf('#q=') >= 0) {
        var oldUrl = $('.wpml-ls-item a').attr('href').split('#')[0];
        $('.wpml-ls-item a').attr('href', oldUrl + hash);
      }
    }

    let searchPublication = location.href.indexOf('?');
    if (searchPublication >= 0) {
      let hashPublication = location.href.substring(searchPublication);
      var oldUrlPublication = $('.wpml-ls-item a').attr('href');
      $('.wpml-ls-item a').attr('href', oldUrlPublication.split('?')[0] + hashPublication + '&changeLang=true');
    }
  });
})(window, jQuery);
